<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-black-900  print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'" [navigation]="navigation" [opened]="!isScreenSmall"
  (openedChanged)="navigationOpenedChanged()">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center p-6 pb-0">
      <!-- Organisation image -->
      @if (organisationLogoUrl) {
        <img class="pl-5 pr-5" [src]="organisationLogoUrl" alt="Logo">
      }

      <!-- Light version -->


      <!-- Dark version -->
      @if (!organisationLogoUrl) {
        <img class="hidden dark:flex" src="assets/images/logo/logo-text-on-dark.png"
          alt="Logo">
      }
    </div>
  </ng-container>

  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationFooter>

    <hr class="m-0">

    <div class="flex flex-col items-center gap-0 px-3 pt-0 pb-1">
      <!-- Stack on mobile; share one row from the Hub's 600px breakpoint. -->
      <div class="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 max-w-full">
        <!-- Smaller badges retain their aspect ratio and 44px click targets. -->
        <!-- <a class="flex items-center justify-center w-[6.4rem] max-w-full min-h-[44px]"
        href="https://play.google.com/store/apps/details?id=com.nuftech.rd" target="_blank">
        <img class="w-full h-auto" src="assets/images/banners/google_play_badge.png" alt="Rugged Data">
      </a> -->

      <a class="flex items-center justify-center w-[6.4rem] max-w-full min-h-[44px]" [href]="webAppLink"
        target="_blank">
        <img class="w-full h-auto" src="assets/images/banners/web_app.png" alt="Rugged Data Web App">
      </a>
    </div>

    <div class="text-center text-[9px] leading-[10px]">Hub v{{ version }}</div>
  </div>

</ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

  <!-- Header -->
  <div
    class="hub-header relative flex flex-0 items-center w-full h-[48px] px-4 md:px-6 py-0 z-49 shadow dark:shadow-none border-b border-solid border-primary-20 dark:border-dark-border bg-card dark:bg-dark print:hidden">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
    <!-- Taskbar Text -->
    <div class="flex pl-2 sm:pl-4 whitespace-nowrap text-[14px] leading-5 font-semibold opacity-80">
      {{ buildEnv }}
    </div>
    <!-- Components -->
    <div class="flex shrink-0 items-center pl-2 ml-auto space-x-1 sm:space-x-2">
      <!--            <languages></languages>-->
      @if (userIsSuper) {
        <button mat-icon-button #tooltip="matTooltip"
          [matTooltip]="hasJustCopiedShareLink ? ('Copied' | transloco) : ('Get Share Link' | transloco)"
          (mouseenter)="hasJustCopiedShareLink = false" (touchstart)="hasJustCopiedShareLink = false"
          (click)="getShareLink(); tooltip.show()">
          <mat-icon [svgIcon]="'heroicons_outline:link'"></mat-icon>
        </button>
      }
      <fuse-fullscreen [tooltip]="'Toggle Fullscreen' | transloco" class="hidden md:block"></fuse-fullscreen>
      <button mat-icon-button [matTooltip]="schemeTooltip | transloco" (click)="toggleUserTheme()">
        <mat-icon [svgIcon]="schemeIcon"></mat-icon>
      </button>

      <!--            <search [appearance]="'bar'"></search>-->
      <!--            <shortcuts></shortcuts>-->
      <!--            <messages></messages>-->
      <!--            <notifications></notifications>-->
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- The @if (true) block lets the router outlet update when the layout changes. -->


    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <!-- <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
  <span class="font-medium text-secondary">Rugged Data &copy; {{currentYear}}</span>
</div> -->

</div>